import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    section {
      display: flex;
      justify-content: center;
      width: 100%;
      border-bottom: var(--nav-border-style);
      height: calc(50em / var(--default-rem-px-count));
      align-items: center;
    }

    form {
      background-color: white;
      display: flex;
      flex-direction: row;
      width: 100%;
    }

    input {
      border: none;
      width: -webkit-fill-available;
      padding-left: calc(10em / var(--default-rem-px-count));
      font-size: calc(14em / var(--default-rem-px-count));
      line-height: calc(32em / var(--default-rem-px-count));
      letter-spacing: -0.21px;
    }

    input:focus {
      outline: none;
    }

    img {
      width: calc(12em / var(--default-rem-px-count));
      height: calc(12em / var(--default-rem-px-count));
      padding: 12px;
    }

    .close-search {
      display: none;
    }

    @media (min-width: 1024px) {
      section {
        border-bottom: none;
        height: inherit;
      }

      form {
        width: calc(667em / var(--default-rem-px-count));
        justify-content: space-between;
      }

      .close-search {
        display: inherit;
        cursor: pointer;
      }
    }
  `,
];
